export const categories = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-sword-line' },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-laugh-line' },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line' },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line' },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line' },
  { slug: 'donghua', name: '动画片', icon: 'ri-magic-line' },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-line' },
  { slug: 'zongyi', name: '综艺', icon: 'ri-live-line' },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-camera-line' },
  { slug: 'xuanyi', name: '悬疑片', icon: 'ri-search-eye-line' },
  { slug: 'zhanzheng', name: '战争片', icon: 'ri-shield-flash-line' },
  { slug: 'gaofen', name: '高分推荐', icon: 'ri-star-line' },
  { slug: 'zuixin', name: '最新上线', icon: 'ri-flashlight-line' },
  { slug: 'jingdian', name: '经典回顾', icon: 'ri-award-line' },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || categories[0];
};